module.exports = __webpack_public_path__ + "static/media/shapes_13.b9fb2c22.svg";